import axios from "axios";
import { BACKEND_URL } from "./apiConfig";
import { log } from "../utils/logger";
import { getAuthToken, getAuthHeader, getPublicHeader } from "./authUtils";

/**
* Fetches the list of products available for sale from the backend.
* Requires a valid authentication token stored in cookies.
*
* @throws Will throw an error if the authentication token is missing.
* @throws Will throw an error if the request fails, including status code and status text.
*
* @returns {Promise<any>} Promise resolving to the product data from the server.
*/
type GetProductOpts = {
    subscriberId?: number | string;
    isPublicView?: boolean;
    uuid?: string;
};
export async function getProducts(
    opts: GetProductOpts
): Promise<any> {
    const { isPublicView, uuid } = opts;

    if(!isPublicView){
        // Normal fetch
        const token = getAuthToken();
        if (typeof uuid !== "string" || uuid.trim() === "" || uuid === "false") {
            throw new Error("UUID must be a non-empty string.");
        }
        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/sales_items?uuid=${uuid}`, {
                headers: getAuthHeader(token),
            });
            log("[Fetch] sales_items:", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }

    }else{
        // Fetch in public view
        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/sales_items?uuid=${uuid}`, {
                headers: getPublicHeader(),
            });
            log("[Fetch] sales_items (public):", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }
    }

}
